import { render, staticRenderFns } from "./LocalBlocks.vue?vue&type=template&id=04554ed2&scoped=true"
import script from "./LocalBlocks.vue?vue&type=script&lang=ts"
export * from "./LocalBlocks.vue?vue&type=script&lang=ts"
import style0 from "./LocalBlocks.vue?vue&type=style&index=0&id=04554ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04554ed2",
  null
  
)

export default component.exports